// LocalStorage tabanlı fiyat teklifi hafızası.
// PriceQuoteModal kaydeder, AppointmentDetailEdit (veya başka consumer) okur ve aktarır.
// Aynı tab içinde değişimleri yakalamak için 'price-quote-changed' custom event'i fırlatılır.
const KEY = 'price-quote-memory';
const EVENT_NAME = 'price-quote-changed';

const emitChange = () => {
    try {
        window.dispatchEvent(new Event(EVENT_NAME));
    } catch {}
};

export const PriceQuoteStorage = {
    save: (data) => {
        try {
            localStorage.setItem(KEY, JSON.stringify({
                ...data,
                savedAt: new Date().toISOString()
            }));
            emitChange();
            return true;
        } catch (e) {
            console.error('PriceQuoteStorage.save failed', e);
            return false;
        }
    },

    get: () => {
        try {
            const raw = localStorage.getItem(KEY);
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            console.error('PriceQuoteStorage.get failed', e);
            return null;
        }
    },

    has: () => {
        try {
            const raw = localStorage.getItem(KEY);
            if (!raw) return false;
            const data = JSON.parse(raw);
            const ops = data?.operationList?.length || 0;
            const others = data?.otherOperations?.length || 0;
            return (ops + others) > 0;
        } catch {
            return false;
        }
    },

    // Belirli bir birim için kullanılabilir operationList döner.
    // Saved op.operation.unitId === unitId olanlar alınır.
    // Hiç eşleşme yoksa null döner (consumer butonu gizlemeli).
    // unitId URL query'den string, API'den number gelebildiği için sayısal karşılaştırma.
    getForUnit: (unitId) => {
        if (!unitId) return null;
        const data = PriceQuoteStorage.get();
        if (!data) return null;
        const target = Number(unitId);
        if (Number.isNaN(target)) return null;
        const matchedOps = (data.operationList || []).filter(
            x => Number(x?.operation?.unitId) === target
        );
        if (matchedOps.length === 0) return null;
        return {
            ...data,
            operationList: matchedOps,
            // Saved quote bu birimle eşleşiyor mu (institution/appointmentType set etmek için)?
            unitMatches: Number(data.unitId) === target,
        };
    },

    clear: () => {
        localStorage.removeItem(KEY);
        emitChange();
    },

    // Belirli bir birime aktarım yapıldığında sadece o birime ait operations'ı + tüm
    // otherOperations'ı (her aktarımda gittikleri için) hafızadan çıkarır.
    // Birim metadata (unitId/unitName/institutionId/appointmentTypeId/currency) korunur.
    removeTransferredForUnit: (unitId) => {
        const data = PriceQuoteStorage.get();
        if (!data) return;
        const target = Number(unitId);
        if (Number.isNaN(target)) return;
        const remaining = (data.operationList || []).filter(
            x => Number(x?.operation?.unitId) !== target
        );
        const newData = {
            ...data,
            operationList: remaining,
            otherOperations: [],
        };
        try {
            localStorage.setItem(KEY, JSON.stringify(newData));
            emitChange();
        } catch (e) {
            console.error('PriceQuoteStorage.removeTransferredForUnit failed', e);
        }
    },

    // Consumer'lar buna abone olur (cleanup unsubscribe döner)
    subscribe: (callback) => {
        const handler = () => callback(PriceQuoteStorage.has());
        window.addEventListener(EVENT_NAME, handler);
        window.addEventListener('storage', handler); // başka tab'tan değişim
        return () => {
            window.removeEventListener(EVENT_NAME, handler);
            window.removeEventListener('storage', handler);
        };
    }
};
